import AntdAvatar from 'components/Avatar'
import Button from 'components/Button/index'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import ConnectionIcon from 'components/icons/ConnectionIcon'
import CandidateDetails from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/CreateSlotDrawer/Components/CandidateDetails'
import { FooterFlex } from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/CreateSlotDrawer/ManyToManyPreview/style'
import {
  AdjustIcon,
  CollageDetailsFlex,
  CollageNameFlex,
  CollegeCity,
  CollegeNameDiv,
  ContentDiv,
  DetailsNameDiv,
  DetailsTitleDiv,
  InterviwerFlex,
  LeftFlex,
  LinkSpan,
  MainFlex,
  RightFlex,
} from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/CreateSlotDrawer/OneToOnePreview/style'
import ScheduledSuccessfully from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/CreateSlotDrawer/ScheduledSuccessfully/index'
import React, { Fragment } from 'react'

const daysOfWeek = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
]
const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]
const ScheduleDetails = ({
  interviewType,
  interviewInfo,
  interviewTime,
  isSingleOrBulk,
  driveInterViewerList,
  selectedCandidate,
  setPrivew,
  scheduleInterview,
  setCreateSlotDrawer,
  preview,
  isLoading,
  candidateInfoData,
  setInterviewType,
  count,
  isBulk,
  setDateArr,
  selectedRoundType,
  dateArr,
}) => {
  const handleConfirm = async () => {
    let response = await scheduleInterview(true, interviewInfo)
    if (response) {
      setInterviewType(false)
    }
    setDateArr([])
  }

  const handleBack = () => {
    setCreateSlotDrawer(true)
    setPrivew(false)
  }

  const formatDate = dateInput => {
    if (!dateInput) return '' // Handle the case where dateInput is undefined or null

    const formatSingleDate = dateString => {
      const date = new Date(dateString)
      if (isNaN(date.getTime())) return '' // Handle invalid dates
      const day = date.getDate()
      const month = months[date.getMonth()]
      const year = date.getFullYear()
      const dayOfWeek = daysOfWeek[date.getDay()]
      return `${day} ${month} ${year} ${dayOfWeek}`
    }

    if (Array.isArray(dateInput)) {
      return dateInput
        .map(formatSingleDate)
        .filter(formattedDate => formattedDate !== '') // Filter out invalid dates
        .join(', ') // Concatenate the dates with commas
    } else {
      return formatSingleDate(dateInput)
    }
  }

  const content = () => {
    return (
      <>
        {(interviewType == 'ASSESMENT' ||
          interviewType === 'EXTERNAL_ASSESMENT') && (
          <>
            {isSingleOrBulk && (
              <CandidateDetails
                selectedCandidate={selectedCandidate}
                count={count}
                isBulk={isBulk}
              />
            )}
            <DetailsTitleDiv>Details</DetailsTitleDiv>
            <RightFlex column>
              <LeftFlex>
                <DetailsNameDiv>Date</DetailsNameDiv>
                <ContentDiv>{formatDate(dateArr)}</ContentDiv>
              </LeftFlex>
              {interviewInfo?.time && (
                <LeftFlex>
                  <DetailsNameDiv>Time</DetailsNameDiv>
                  <ContentDiv>
                    {interviewTime.timeRange[0]} &nbsp;To&nbsp;{' '}
                    {interviewTime.timeRange[1]}
                  </ContentDiv>
                </LeftFlex>
              )}
              <LeftFlex>
                <DetailsNameDiv>Duration</DetailsNameDiv>
                <ContentDiv>{interviewInfo?.duration} Mins</ContentDiv>
              </LeftFlex>
              <LeftFlex>
                <DetailsNameDiv>Interview type</DetailsNameDiv>{' '}
                <ContentDiv>
                  {interviewInfo?.interviewType?.toLowerCase()}
                </ContentDiv>
              </LeftFlex>

              <LeftFlex>
                <DetailsNameDiv>Interview Mode</DetailsNameDiv>
                <ContentDiv>
                  {interviewInfo?.mode === 'EXTERNAL_LINK_1'
                    ? 'Google Meet'
                    : interviewInfo?.mode === 'OFFLINE'
                    ? interviewInfo?.mode?.toLowerCase()
                    : 'External Link'}
                </ContentDiv>
              </LeftFlex>

              {interviewInfo?.location && (
                <LeftFlex>
                  <DetailsNameDiv>Location</DetailsNameDiv>
                  <ContentDiv>
                    {interviewInfo?.location?.toLowerCase()}
                  </ContentDiv>
                </LeftFlex>
              )}

              {interviewInfo?.linkAndPanel[0]?.panel && (
                <LeftFlex>
                  <DetailsNameDiv>Interviewer</DetailsNameDiv>
                  <ContentDiv>{driveInterViewerList?.length}</ContentDiv>
                </LeftFlex>
              )}

              {interviewInfo?.linkAndPanel[0]?.link && (
                <LeftFlex>
                  <DetailsNameDiv>Link</DetailsNameDiv>
                  <ContentDiv noCap>
                    <LinkSpan
                      href={interviewInfo?.linkAndPanel[0]?.link}
                      target="_blank"
                    >
                      {interviewInfo?.linkAndPanel[0]?.link || '-'}
                    </LinkSpan>
                  </ContentDiv>
                </LeftFlex>
              )}

              <LeftFlex>
                <DetailsNameDiv>Instructions</DetailsNameDiv>{' '}
                <ContentDiv style={{ whiteSpace: 'pre-wrap' }}>{interviewInfo?.instructions || '-'}</ContentDiv>
              </LeftFlex>
            </RightFlex>
          </>
        )}
        {interviewType == 'FACE_TO_FACE' && !isSingleOrBulk && (
          <div>
            <MainFlex>
              <AdjustIcon>
                <ConnectionIcon />
              </AdjustIcon>
              <InterviwerFlex column>
                <CollageDetailsFlex spaceBetween centerVertically>
                  <Flex alignCenter>
                    <AntdAvatar
                      size={36}
                      IconName={candidateInfoData?.student?.firstName?.charAt(
                        0
                      )}
                    />

                    <CollageNameFlex>
                      <CollegeNameDiv>
                        {candidateInfoData?.student?.firstName}{' '}
                        {candidateInfoData?.student?.lastName}
                      </CollegeNameDiv>
                      {}
                      {}
                    </CollageNameFlex>
                  </Flex>
                </CollageDetailsFlex>
                {interviewInfo?.linkAndPanel[0]?.panel?.map((data, index) => {
                  return (
                    <CollageDetailsFlex
                      spaceBetween
                      centerVertically
                      key={index + data?.firstName}
                    >
                      <Flex alignCenter>
                        <AntdAvatar
                          size={36}
                          IconName={data?.firstName?.charAt(0)}
                        />

                        <CollageNameFlex>
                          <CollegeNameDiv>
                            {data?.firstName} {data?.lastName}
                          </CollegeNameDiv>
                          <CollegeCity>{data?.email}</CollegeCity>
                        </CollageNameFlex>
                      </Flex>
                    </CollageDetailsFlex>
                  )
                })}
              </InterviwerFlex>
            </MainFlex>
            <DetailsTitleDiv>Details</DetailsTitleDiv>
            <RightFlex column>
              <LeftFlex>
                <DetailsNameDiv>Date</DetailsNameDiv>
                <ContentDiv>{formatDate(dateArr)}</ContentDiv>
              </LeftFlex>
              <LeftFlex>
                <DetailsNameDiv>Time</DetailsNameDiv>
                <ContentDiv>
                  {interviewTime.timeRange[0]} &nbsp;To&nbsp;{' '}
                  {interviewTime.timeRange[1]}
                </ContentDiv>
              </LeftFlex>
              <LeftFlex>
                <DetailsNameDiv>Mode</DetailsNameDiv>
                <ContentDiv>
                  {interviewInfo?.mode === 'EXTERNAL_LINK_1'
                    ? 'Google Meet'
                    : interviewInfo?.mode === 'OFFLINE'
                    ? interviewInfo?.mode?.toLowerCase()
                    : 'External Link'}
                </ContentDiv>
              </LeftFlex>
              <LeftFlex>
                <DetailsNameDiv>Instructions</DetailsNameDiv>{' '}
                <ContentDiv style={{ whiteSpace: 'pre-wrap' }}>{interviewInfo?.instructions || '-'}</ContentDiv>
              </LeftFlex>
            </RightFlex>
          </div>
        )}
        {(interviewType == 'GROUP' || interviewType == 'FACE_TO_FACE') &&
          isSingleOrBulk && (
            <div>
              <DetailsTitleDiv>Details</DetailsTitleDiv>
              <RightFlex column>
                <LeftFlex>
                  <DetailsNameDiv>Round Name</DetailsNameDiv>
                  <ContentDiv>{interviewInfo?.interviewRound}</ContentDiv>
                </LeftFlex>
                <LeftFlex>
                  <DetailsNameDiv>Round Type</DetailsNameDiv>{' '}
                  <ContentDiv>
                    {interviewInfo?.interviewType === 'FACE_TO_FACE'
                      ? 'Face to Face'
                      : interviewInfo?.interviewType === 'GROUP'
                      ? 'Group Discussion'
                      : interviewInfo?.interviewType?.toLowerCase()}
                  </ContentDiv>
                </LeftFlex>
                <LeftFlex>
                  <DetailsNameDiv>Date</DetailsNameDiv>
                  <ContentDiv>{formatDate(dateArr)}</ContentDiv>
                </LeftFlex>
                <LeftFlex>
                  <DetailsNameDiv>Time</DetailsNameDiv>
                  <ContentDiv>
                    {interviewTime.timeRange[0]} &nbsp;To&nbsp;{' '}
                    {interviewTime.timeRange[1]}
                  </ContentDiv>
                </LeftFlex>
                <LeftFlex>
                  <DetailsNameDiv>Duration</DetailsNameDiv>
                  <ContentDiv>{interviewInfo?.duration} Min(Each)</ContentDiv>
                </LeftFlex>
                <LeftFlex>
                  <DetailsNameDiv>Interview Mode</DetailsNameDiv>
                  <ContentDiv>
                    {interviewInfo?.mode === 'EXTERNAL_LINK_1'
                      ? 'Google Meet'
                      : interviewInfo?.mode === 'OFFLINE'
                      ? interviewInfo?.mode?.toLowerCase()
                      : 'External Link'}
                  </ContentDiv>
                </LeftFlex>

                {interviewInfo?.location && (
                  <LeftFlex>
                    <DetailsNameDiv>Location</DetailsNameDiv>
                    <ContentDiv>
                      {interviewInfo?.location?.toLowerCase()}
                    </ContentDiv>
                  </LeftFlex>
                )}

                {interviewInfo?.linkAndPanel[0]?.panel && (
                  <LeftFlex>
                    <DetailsNameDiv>Interviewer</DetailsNameDiv>
                    <ContentDiv>{driveInterViewerList?.length}</ContentDiv>
                  </LeftFlex>
                )}

                {interviewInfo?.linkAndPanel && (
                  <LeftFlex>
                    <DetailsNameDiv>Panel</DetailsNameDiv>
                    <ContentDiv>
                      <LinkSpan>
                        {interviewInfo?.linkAndPanel?.length || '0'}
                      </LinkSpan>
                    </ContentDiv>
                  </LeftFlex>
                )}

                <LeftFlex>
                  <DetailsNameDiv>Instructions</DetailsNameDiv>{' '}
                  <ContentDiv style={{ whiteSpace: 'pre-wrap' }}>{interviewInfo?.instructions || '-'}</ContentDiv>
                </LeftFlex>
              </RightFlex>{' '}
            </div>
          )}
        {!interviewType && (
          <ScheduledSuccessfully
            interviewType={interviewType}
            setPrivew={setPrivew}
            isSingleOrBulk={isSingleOrBulk}
            interviewInfo={interviewInfo}
            selectedRoundType={selectedRoundType}
          />
        )}
      </>
    )
  }

  const footer = () => {
    return (
      <Fragment>
        {interviewType && (
          <FooterFlex flexEnd>
            <Button.Secondary
              width="88px"
              height="38px"
              text="Back"
              onClick={handleBack}
            />
            <Button.Primary
              width="95px"
              height="38px"
              text="Proceed"
              onClick={handleConfirm}
              loading={isLoading}
            />
          </FooterFlex>
        )}
      </Fragment>
    )
  }
  return (
    <Drawer
      width="43%"
      title={'Preview'}
      placement="right"
      visible={preview}
      content={content()}
      footer={footer()}
      onClose={() => {
        setPrivew(false)
      }}
      closable
    />
  )
}

export default ScheduleDetails
